import Items from "../../diseases/items/items";
import { Title } from "../../global/title/title";
import { Link } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";

export const Diseases = ({ items }) => {
  return (
    <div className="section container diseases-sec">
      <Title black="some of" blue="diseases" />
      <Carousel infiniteLoop useKeyboardArrows autoPlay>
        <Items list={items.slice(0, 3)} search={false} link="/diseases/1" />
        <Items list={items.slice(3, 6)} search={false} link="/diseases/1" />
      </Carousel>
      <div className="text">
        <Link to="/diseases" className="heading__ternary  text--blue">
          see all
        </Link>
      </div>
    </div>
  );
};
